module.exports = __webpack_public_path__ + "img/bespoke70_13.072d86ae.jpg";